Ext.define('SA.SvgLinearLayout', {
    singleton: true,

    create({content, center = false, gap = 0, vertical = false}) {
        var getSize = el => vertical ? SA.Svg.getRect(el).bottom : SA.Svg.getRect(el).right,
            getCrossSize = el => vertical ? SA.Svg.getRect(el).right : SA.Svg.getRect(el).bottom,
            svg = SA.HiddenDom.attach(SA.Svg.create({type: 'svg'})),
            el = svg.appendChild(SA.Svg.create({type: 'g', content})),
            children = Array.from(el.children),
            maxCrossSize = Math.max(...children.map(getCrossSize)),
            offset = 0;

        children.forEach(child => {
            var cross = center ? (maxCrossSize - getCrossSize(child)) / 2 : 0,
                x = vertical ? cross : offset,
                y = vertical ? offset : cross;

            SA.Svg.setAttr(child, 'transform', `translate(${x} ${y})`);

            offset += getSize(child) + gap;
        });

        el.remove();
        svg.remove();

        return el;
    }
});